import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ve_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export const fetchCategories = () => api.get("/categories").then((r) => r.data);
export const fetchCategory = (id) =>
  api.get(`/categories/${id}`).then((r) => r.data);
export const fetchBrands = (categoryId) =>
  api
    .get("/brands", { params: { category_id: categoryId } })
    .then((r) => r.data);
export const fetchBrand = (id) => api.get(`/brands/${id}`).then((r) => r.data);
export const fetchProducts = (params) =>
  api.get("/products", { params }).then((r) => r.data);
export const submitBOQ = (formData) =>
  api
    .post("/boq", formData, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
export const adminLogin = (username, password) =>
  api.post("/admin/login", { username, password }).then((r) => r.data);
export const adminMe = () => api.get("/admin/me").then((r) => r.data);
export const adminListBOQs = () => api.get("/admin/boqs").then((r) => r.data);
export const adminDeleteBOQ = (id) =>
  api.delete(`/admin/boqs/${id}`).then((r) => r.data);
export const adminUploadCatalog = (brandId, file, onProgress) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post(`/admin/brands/${brandId}/catalog`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (e) => {
        if (onProgress && e.total) {
          onProgress(Math.round((e.loaded * 100) / e.total));
        }
      },
    })
    .then((r) => r.data);
};
export const adminDeleteCatalog = (brandId) =>
  api.delete(`/admin/brands/${brandId}/catalog`).then((r) => r.data);
export const adminCreateProduct = (data) =>
  api.post("/admin/products", data).then((r) => r.data);
export const adminUpdateProduct = (id, data) =>
  api.put(`/admin/products/${id}`, data).then((r) => r.data);
export const adminDeleteProduct = (id) =>
  api.delete(`/admin/products/${id}`).then((r) => r.data);
export const adminUploadProductImage = (productId, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post(`/admin/products/${productId}/image`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const adminUploadProductImages = (productId, files) => {
  const fd = new FormData();
  Array.from(files).forEach((f) => fd.append("files", f));
  return api
    .post(`/admin/products/${productId}/images`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const adminDeleteProductImage = (productId, imageId) =>
  api.delete(`/admin/products/${productId}/images/${imageId}`).then((r) => r.data);
export const productImageSrc = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  const BACKEND = process.env.REACT_APP_BACKEND_URL;
  return url.startsWith("/api") ? `${BACKEND}${url}` : url;
};
export const adminUploadCategoryImage = (categoryId, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post(`/admin/categories/${categoryId}/image`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const adminResetCategoryImage = (categoryId) =>
  api.delete(`/admin/categories/${categoryId}/image`).then((r) => r.data);
export const adminCreateBrand = (data) =>
  api.post("/admin/brands", data).then((r) => r.data);
export const adminUpdateBrand = (id, data) =>
  api.put(`/admin/brands/${id}`, data).then((r) => r.data);
export const adminDeleteBrand = (id) =>
  api.delete(`/admin/brands/${id}`).then((r) => r.data);
export const adminUploadBrandLogo = (brandId, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post(`/admin/brands/${brandId}/logo`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const adminDeleteBrandLogo = (brandId) =>
  api.delete(`/admin/brands/${brandId}/logo`).then((r) => r.data);

export const fetchBrandSeries = (brandId) =>
  api.get(`/brands/${brandId}/series`).then((r) => r.data);
export const adminCreateSeries = (brandId, data) =>
  api.post(`/admin/brands/${brandId}/series`, data).then((r) => r.data);
export const adminUpdateSeries = (id, data) =>
  api.put(`/admin/series/${id}`, data).then((r) => r.data);
export const adminDeleteSeries = (id) =>
  api.delete(`/admin/series/${id}`).then((r) => r.data);
export const adminReorderSeries = (brandId, ids) =>
  api.post(`/admin/brands/${brandId}/series/reorder`, { ids }).then((r) => r.data);
export const adminUploadSeriesCatalog = (seriesId, file, onProgress) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post(`/admin/series/${seriesId}/catalog`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (e) => {
        if (onProgress && e.total) {
          onProgress(Math.round((e.loaded * 100) / e.total));
        }
      },
    })
    .then((r) => r.data);
};
export const adminDeleteSeriesCatalog = (seriesId) =>
  api.delete(`/admin/series/${seriesId}/catalog`).then((r) => r.data);
export const seriesCatalogUrl = (seriesId) =>
  `${API}/files/series-catalog/${seriesId}`;
export const seriesCatalogViewUrl = (seriesId) =>
  `${API}/files/series-catalog/${seriesId}?inline=true`;

export const catalogDownloadUrl = (brandId) =>
  `${API}/files/catalog/${brandId}`;
export const catalogViewUrl = (brandId) =>
  `${API}/files/catalog/${brandId}?inline=true`;

// Showroom photos
export const fetchShowroomPhotos = () =>
  api.get("/showroom-photos").then((r) => r.data);
export const adminUploadShowroomPhotos = (files) => {
  const fd = new FormData();
  Array.from(files).forEach((f) => fd.append("files", f));
  return api
    .post("/admin/showroom-photos", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const adminDeleteShowroomPhoto = (id) =>
  api.delete(`/admin/showroom-photos/${id}`).then((r) => r.data);
